import { Component, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { Tab } from '../tab/tab.component';
import { OauthHelper } from '../../services/webservice'
import { JwtHelper } from 'angular2-jwt';

@Component({
	selector: 'tabs',
	templateUrl: "./tabs.html",
	styles: [require("./tabs.scss")]
})
export class Tabs implements AfterContentInit {

	constructor(
		private jwtHelper: JwtHelper,
		private oauthHelper: OauthHelper
	) {	}

	@ContentChildren(Tab) tabs: QueryList<Tab>;

	// contentChildren are set
	ngAfterContentInit() {
		// get all active tabs
		let activeTabs = this.tabs.filter((tab) => tab.active);

		// if there is no active tab set, activate the first
		if (activeTabs.length === 0) {
			this.selectTab(this.tabs.first);
		}
	}

	selectTab(tab: Tab) {
		// do not select disabled tab
		if (tab.disabled === true) {
			return;
		}

		// deactivate all tabs
		this.tabs.toArray().forEach(tabItem => tabItem.active = false);

		// activate the tab the user has clicked on.
		tab.active = true;
	}

	protected roleIsCorrect(role: string) {
		let decodedToken = this.jwtHelper.decodeToken(this.oauthHelper.getAccessToken());
		let springRole = "ROLE_" + role
		for (let authority of decodedToken.authorities) {
			if (authority === springRole) {
				return true;
			}
		}
		return false;
	}

}



// WEBPACK FOOTER //
// ./src/app/ui-helper/tabs/tabs.component.ts